import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const ScreenNameStyles = styled(OnboardingPage)`
  // animation vars
  --animation-color-100: rgba(255, 255, 255, 1);
  --animation-color-50: rgba(255, 255, 255, 0.5);
  --animation-color-0: rgba(255, 255, 255, 0);

  ion-content {
    --padding-start: 10px;
    --padding-end: 10px;
  }

  .response {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: 20px 0 0;

    .response-start {
      color: transparent;
    }

    .transparent-with-shadow {
      color: transparent;
      text-shadow: 0 0 0.3em var(--animation-color-100);
    }

    .color-without-shadow {
      color: var(--animation-color-100);
      text-shadow: 0 0 0em var(--animation-color-0);
    }
  }
`;
